import React, { useEffect } from 'react';
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { gameOverDisplayState } from '../globalStates/general/gameOver';
import { useRecoilState } from 'recoil';



const GameOver = () => {
  const [gameover, setGameover] = useRecoilState(gameOverDisplayState);
  useEffect(() => {
    if (gameover === "display") {
      document.querySelector('body').style.overflowY = 'hidden';
      document.querySelector('html').style.overflowY = 'hidden';
    }
  }, [gameover])
  const wrap = css`
    display: ${gameover};
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    -webkit-backdrop-filter: blur(3px);
    backdrop-filter: blur(3px);
    background-color: rgba(191, 212, 235, 0.5);
    z-index: 100;

  `;
  const gameOverStyle = css`
      display: flex;
      flex-direction: column;
      margin-top: 250px;
      align-items: center;
      h3 {
        font-size: 2em;
        color: #555;
      }
  `;
  return (
    <div css={wrap}>
      <div css={gameOverStyle}>
        <h3>GAME OVER</h3>
        <h4><a href="/">Retry</a></h4>
      </div>
    </div>
  )
}

export default GameOver
